import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { OrderEventType, QuoteOrderLine, QuoteOrderLineNotificationSchedule } from '../../models/models';

@Component({
    selector: 'quoteorderlinenotificationschedule-form',
    templateUrl: './quoteorderlinenotificationschedule-form.component.html',
    standalone: false
})
export class QuoteOrderLineNotificationScheduleForm implements OnChanges {
    @Input() quoteOrderLineID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public sched: QuoteOrderLineNotificationSchedule = {} as QuoteOrderLineNotificationSchedule;
    public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public orderEventTypeList: OrderEventType[] = [];

    constructor(private orderService: OrderService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.orderService.getOrderEventTypes().subscribe(result => {
            this.orderEventTypeList = result.resultCollection;
            this.orderEventTypeList = this.orderEventTypeList.filter(t => t.isNotificationSchedule == true);
            this.orderEventTypeList = this.orderEventTypeList.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
        });
        //console.log("ngOnInit", this.quoteOrderLineID);
    }

    ngOnChanges() {
        this.utilService.isLoading = true;
        this.orderService.getQuoteOrderLineById(this.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            this.quoteOrderLine = result;
            console.log("ngOnChanges", this.quoteOrderLineID, this.quoteOrderLine);
        });
        this.orderService.getQuoteOrderLineNotificationScheduleByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            var employeeId = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
            if (result.resultCollection.length > 0) {
                this.sched = result.resultCollection[0];
                if (this.sched.quoteOrderLineID == 0) {
                    this.getNewSched(employeeId);
                }
                else {
                    this.sched.modifiedByEmployeeID = employeeId;
                }
            }
            else {
                this.getNewSched(employeeId);
            }
            console.log("ngOnChanges", this.quoteOrderLineID, this.quoteOrderLine);
        });
    }

    private getNewSched(employeeId: number) {
        this.sched.quoteOrderLineNotificationScheduleID = 0;
        this.sched.quoteOrderLineID = this.quoteOrderLineID;
        this.sched.hoursToCheck = 1;
        this.sched.notes = "";
        this.sched.instructions = "";
        this.sched.notificationEmails = "";
        this.sched.orderEventTypeID = 0;
        this.sched.createdByEmployeeID = employeeId;
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.sched, this.quoteOrderLine);
        this.orderService.saveQuoteOrderLineNotificationSchedule(this.sched).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                //this.getCustomers();
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        //this.quoteOrderLine = {} as QuoteOrderLine;
        //this.sched = {} as QuoteOrderLineNotificationSchedule;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
